import type { MenuSelectionDetails } from '@ark-ui/solid'
import { IconButton, Menu, appDialogConfirm } from '@components'
import { Archive, Ellipsis, PencilLine, Star, Trash } from 'lucide-solid'
import { createSignal, Show } from 'solid-js'
import { useService } from 'solid-services'
import { HStack } from 'styled-system/jsx'
import { useCreate } from '../../../Create/state'
import { useSingle } from '../../state'
import { SingalPhq } from './SignalPhq'
import { useAuth } from '@state'

enum Options {
	Archive = 'Archive',
	Edit = 'Edit',
	PotentialHighQuality = 'PotentialHighQuality',
	Delete = 'Delete',
}

export default function (props: Menu.RootProps) {
	const {
		onArchiveSetup,
		onDeleteSetup,
		setupResource,
		setupPotentialHigQualityResource,
	} = useService(useSingle)()
	const { editSetup } = useService(useCreate)()
	const { canSignalPhq } = useService(useAuth)()
	const [isOpen, setIsOpen] = createSignal(false)

	const onSelect = (details: MenuSelectionDetails) => {
		switch (details.value) {
			case Options.Archive:
				appDialogConfirm(
					onArchiveSetup,
					'Are you sure you want to archive this Setup?',
				)()
				break

			case Options.Delete:
				appDialogConfirm(onDeleteSetup, 'Are you sure you want to delete this Setup?')()
				break

			case Options.Edit:
				// biome-ignore lint/suspicious/noExplicitAny: <explanation>
				editSetup(setupResource() as any)
				break

			case Options.PotentialHighQuality:
				setIsOpen(true)
				break
		}
	}

	return (
		<>
			<SingalPhq
				isOpen={isOpen()}
				setIsOpen={setIsOpen}
			/>
			<Menu.Root
				onSelect={onSelect}
				positioning={{
					placement: 'left-start',
				}}
			>
				<Menu.Trigger
					asChild={(triggerProps) => (
						<IconButton
							{...triggerProps()}
							variant="outline"
							size="xs"
						>
							<Ellipsis />
						</IconButton>
					)}
				/>
				<Menu.Positioner>
					<Menu.Content>
						<Menu.ItemGroup>
							<Show when={canSignalPhq()}>
								<Menu.Item
									disabled={!!setupPotentialHigQualityResource()}
									value={Options.PotentialHighQuality}
									color="fg"
								>
									<HStack gap={2}>
										<Star fill="gold" />
										{setupPotentialHigQualityResource() ? 'PHQ Signaled' : 'Sginal PHQ'}
									</HStack>
								</Menu.Item>
							</Show>
							<Menu.Item
								value={Options.Edit}
								color="fg"
							>
								<HStack gap={2}>
									<PencilLine />
									Edit
								</HStack>
							</Menu.Item>
							<Menu.Item value={Options.Archive}>
								<HStack gap="2">
									<Archive />
									Archive
								</HStack>
							</Menu.Item>
							<Menu.Item
								value={Options.Delete}
								color="fg.error"
							>
								<HStack gap={2}>
									<Trash color="var(--colors-fg-error)" />
									Delete
								</HStack>
							</Menu.Item>
						</Menu.ItemGroup>
					</Menu.Content>
				</Menu.Positioner>
			</Menu.Root>
		</>
	)
}
